var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prd-grid-wrapper',{staticClass:"mb-0 shadow-sm",attrs:{"data-items":_vm.payments,"columns":_vm.paymentStatussesColumns}})}
var staticRenderFns = []

export { render, staticRenderFns }